// Opties (varianten) van een cluster, bijv. meerdere mogelijke opstelplekken.
// Zelfde afspraak als de backend (services/clusters.js): optie 1 gebruikt de
// gewone id's, optie n > 1 krijgt "@n" achter het sectie-id en het upload-item-id.

export function parseVariant(id) {
    const m = /^(.+)@([1-9]\d?)$/.exec(String(id));
    return m ? { base: m[1], variant: Number(m[2]) } : { base: String(id), variant: 1 };
}

export function variantKey(base, variant) {
    return variant > 1 ? `${base}@${variant}` : base;
}

/** Stand van de opties van een cluster voor dit project, of null als het cluster geen opties kent. */
export function variantState(project, cluster) {
    const cfg = cluster?.variants;
    if (!cfg) { return null; }
    const st = project?.metadata?.variants?.[cluster.id] || {};
    const max = cfg.max || 6;
    const count = Math.min(Math.max(parseInt(st.count, 10) || 1, 1), max);
    const preferred = Math.min(Math.max(parseInt(st.preferred, 10) || 1, 1), count);
    return { count, preferred, names: st.names || {}, max, label: cfg.label || 'Optie' };
}

/** { E: 2 }: de voorkeursoptie per cluster met opties. */
export function preferredVariants(project, config) {
    const out = {};
    for (const cluster of config?.clusters || []) {
        const st = variantState(project, cluster);
        if (st) { out[cluster.id] = st.preferred; }
    }
    return out;
}
